<template>
  <div class="modal" id="Modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div id="ModalContent" class="modal__content modal__content--lg" v-if="task">
        <div class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200">
          <h2 class="font-medium text-base mr-auto">
              {{task.name}} - (<b>{{task.date}})</b>
          </h2>
          <button type="button" class="close" @click="$emit('closeModal')"><span aria-hidden="true">×</span></button>
        </div>
        <div class="intro-y box py-5">
            <div class="wizard flex flex-col px-5 scroll-modal">
              <div class="bg-gray-200 p-2 rounded-md">
                <p class="mb-2">
                  {{task.campaign_attribute.project_name}} -
                  {{task.campaign_attribute.project_account_name}} -
                  {{task.campaign_attribute.project_account_country_prefix}} -
                  {{task.campaign_attribute.name}}
                </p>
                <p class="mb-2">
                  <b>Creada el día:</b> {{task.created_at}}
                  <b>por</b> {{task.user_created_name}}
                </p>
                <div class="mb-2">
                  {{task.description}} <br>
                  <template v-if="task.path">
                    <a v-for="taskPath in task.path.split(',')"
                      class="text-blue-500"
                      :href="taskPath"
                      target="_blank">
                      Ver archivo aquí
                      <span class="text-gray-500">,</span>
                    </a>
                  </template>
                </div>
                <p class="mb-2">
                  La tarea fue realizada por <b>{{task.user_name}}</b> en un total
                  de <b>{{task.hours}}</b> hora(s)
                </p>
                <p class="mb-2"><b>Respuesta</b></p>
                <p class="mb-2">
                  {{task.response_observations}} <br v-if="task.response_observations">
                  <template v-if="task.response_path">
                    <a v-for="taskResponsePath in task.response_path.split(',')"
                      class="text-blue-500"
                      :href="taskResponsePath"
                      target="_blank">
                      Ver archivo aquí
                      <span class="text-gray-500">,</span>
                    </a>
                  </template>
                </p>
              </div>
              <hr class="my-3">
              <p class="mb-2 text-center text-blue-800"><b>Versiones</b></p> <hr class="mb-2">
              <div class="bg-gray-100 rounded-md mb-2 p-2" v-for="(version, index) in versions" :key="version.id">
                <p class="mb-2">
                  {{version.campaign_attribute.project_name}} -
                  {{version.campaign_attribute.project_account_name}} -
                  {{version.campaign_attribute.project_account_country_prefix}} -
                  {{version.campaign_attribute.name}} -
                  {{`Versión ${index + 1}`}}
                </p>
                <p class="mb-2">
                  <b>Creada el día:</b> {{version.created_at}}
                  <b>por</b> {{version.user_created_name}}
                </p>
                <div class="mb-2">
                  {{version.description}} <br>
                  <template v-if="version.path">
                    <a v-for="taskPath in version.path.split(',')"
                      class="text-blue-500"
                      :href="taskPath"
                      target="_blank">
                      Ver archivo aquí
                      <span class="text-gray-500">,</span>
                    </a>
                  </template>
                </div>
                <p class="mb-2">
                  La tarea fue realizada por <b>{{version.user_name}}</b> en un total
                  de <b>{{version.hours}}</b> hora(s)
                </p>
                <p class="mb-2"><b>Respuesta</b></p>
                <p class="mb-2">
                  {{version.response_observations}} <br v-if="version.response_observations">
                  <template v-if="version.response_path">
                    <a v-for="taskResponsePath in version.response_path.split(',')"
                      class="text-blue-500"
                      :href="taskResponsePath"
                      target="_blank">
                      Ver archivo aquí
                      <span class="text-gray-500">,</span>
                    </a>
                  </template>
                </p>
              </div>
            </div>
        </div>
      </div>
      <app-loading v-else />
  </div>
</template>

<script>
  import Loading from '@/components/admin/partials/LoadingWhite'
	import { mapGetters, mapActions } from 'vuex'
  import { SHOW_TASKVERSION } from '@/vuex/entity/mutation-types'

	export default {
    name: 'ViewTaskModal',
    props: [
      'task'
    ],
    data() {
      return {
        versions: {},
        errors: [],
      }
    },
    mounted() {
      this.getListChildrenTaks();
    },
    async beforeMount () {
      document.body.className = 'overflow-hidden';
    },
    beforeDestroy() {
      document.body.classList.remove('overflow-hidden');

      this.$store.commit(SHOW_TASKVERSION, [])
    },
    methods: {
      async getListChildrenTaks() {
        if (!this.task || !this.task.id) {
          return
        }

        try {
          await this.get(`task/children-finished/${this.task.id}`)
          .then(data => {
            this.versions = data.model
          })
        } catch (error) {
          window.$toast.error(error)
        } finally {

        }
      },
      ...mapActions([
        'get',
      ])
    },
    components: {
      appLoading: Loading,
    },
    computed: {
    },
	}
</script>

<style>
  #Modal {
    visibility: initial;
    opacity: unset;
    z-index: 100000000000;
    margin: unset;
    display: flex
  }

  #ModalContent {
    margin-top: auto;
    margin-bottom: auto
  }
</style>



// WEBPACK FOOTER //
// ViewTaskModal.vue?f20711ce